import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { PRODUCT_STEPS, DEMO_URL, STEP_IMAGES } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { Reveal } from '../ui/Reveal';
import { StepVisual, type StepId } from './product/StepVisual';
import { StepImage } from './product/StepImage';
import { cn } from '../../src/lib/utils';
function StepMedia({
  step
}: {
  step: StepId;
}) {
  const image = STEP_IMAGES[step];
  return image ? <StepImage image={image} data-id="element-321" data-mp="f2627blpahi5" /> : <StepVisual step={step} data-id="element-322" data-mp="f0ux98gir3pg" />;
}

/** Five-step product story. Each step pairs its text (left) with its own product visual (right). */
export function ProductStory() {
  return <section id="platform" aria-labelledby="story-heading" className="border-b border-hairline-soft bg-ink" data-id="element-323" data-mp="os8s32xizfc9">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-324" data-mp="12rqkrtdxzcqw">
        <SectionHeading eyebrow="The Platform" headingId="story-heading" title={<>
              From Dealflow to <em data-id="element-326" data-mp="3ealpyrbd1ufs">Investment Decision.</em>
            </>} description="One workspace per fund — from the first inbound deck to the IC memo, and on to the companies that never reached your inbox." data-id="element-325" data-mp="xsx4xub6n9nk" />

        <ol className="mt-14 flex flex-col gap-6 lg:gap-0" data-id="element-327" data-mp="3s7s4g9p1x6z7">
          {PRODUCT_STEPS.map((step, index) => <li key={step.id} className={cn('grid items-center gap-6 rounded-2xl border border-hairline bg-panel p-6 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16 lg:rounded-none lg:border-0 lg:bg-transparent lg:px-0 lg:py-14', index > 0 && 'lg:border-t lg:border-hairline-soft')} data-id="element-328" data-mp="12io79qv072s" data-mpi={index}>
              <Reveal as="article" className="lg:border-l-2 lg:border-lime lg:pl-8" data-id="element-329" data-mp="jsi69coa8lwp">
                <p className="font-mono text-xs text-lime" data-id="element-330" data-mp="orbd4m92denw">STEP {step.number}</p>
                <h3 className="mt-2 text-2xl font-semibold uppercase tracking-[-0.01em] text-text-primary sm:text-[28px]" data-id="element-331" data-mp="op8q8b37k1ne">
                  {step.title}
                </h3>
                <p className="mt-3 max-w-md text-[15px] leading-relaxed text-text-secondary" data-id="element-332" data-mp="2gufokctffbor">{step.body}</p>
                <ul className="mt-4 flex flex-wrap gap-1.5" data-id="element-333" data-mp="2ulkg0rmn4xo0">
                  {step.tags.map(tag => <li key={tag} className={cn('rounded-md border px-2 py-1 text-[11px]', tag === 'Fit Score' || tag === 'Deal Radar' ? 'border-lime/30 bg-lime/10 text-lime' : 'border-hairline-soft bg-elevated text-text-secondary')} data-id="element-334" data-mp="2prg928ddkpmx">
                      {tag}
                    </li>)}
                </ul>

                {step.id === 'radar' ? <CtaButton href={DEMO_URL} event="deal_radar_cta_click" size="lg" className="mt-6" data-id="element-335" data-mp="1e72pazjwjm08">
                    See It on Your Thesis
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-336" data-mp="3pvpe394b3bg3" />
                  </CtaButton> : null}
              </Reveal>

              <Reveal delay={0.08} data-id="element-337" data-mp="3gzzzbixd5fbo">
                <StepMedia step={step.id} data-id="element-338" data-mp="3gyympa0p8kru" />
              </Reveal>
            </li>)}
        </ol>

      </div>
    </section>;
}